import React from 'react';

interface RouteProgressBarProps {
  isPending: boolean;
}

const RouteProgressBar: React.FC<RouteProgressBarProps> = ({ isPending }) => {
  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-[100] h-1 bg-primary origin-left transition-transform duration-500 ease-out ${
        isPending ? 'scale-x-100 opacity-100' : 'scale-x-0 opacity-0'
      }`}
      style={{
        transitionProperty: 'transform, opacity',
        transitionDelay: isPending ? '0ms' : '200ms'
      }}
    />
  );
};

export default RouteProgressBar;